import { createDomain } from 'effector';

import { type Document } from 'types/zod/document';
import { type QuestionnaireInstance } from 'types/zod/questionnaire-instance';

const domain = createDomain('pages/docs-generation');

const $$docsGeneration = {
    $qInstance: domain.store<QuestionnaireInstance | null>(null),
    $qInstanceId: domain.store<number | null>(null),
    $jobId: domain.store<number | null>(null),

    pollingFx: domain.effect<{ id: number; job: number }, Document[]>(),
};

export default $$docsGeneration;
